export default function () {
  return [
    {
      type: 'Input',
      title: '提交时间',
      [$field]: 'adviceTime',
      rules: [''],
      colSpan: 8,
      readOnly: true
    },
    {
      type: 'Input',
      title: '标题',
      [$field]: 'title',
      rules: [''],
      colSpan: 24,
      readOnly: true,
      placeholder: '请输入'
    },
    {
      type: 'Checkbox',
      title: '心声建议类型',
      [$field]: 'typeCodes',
      colSpan: 8,
      optionList: this.getTypeCodesOptionList,
      rules: ['required']
    },
    {
      type: 'Input',
      title: '其他类型描述',
      [$field]: 'otherTypeDesc',
      rules: [''],
      // colSpan: 8,
      readOnly: true
    },
    {
      type: 'Input',
      title: '所属组织',
      [$field]: 'orgName',
      rules: ['required'],
      colSpan: 24,
      readOnly: true
    },
    {
      type: 'textarea',
      title: '心声建议说明',
      [$field]: 'adviceDesc',
      rules: [''],
      colSpan: 24,
      readOnly: true,
      placeholder: '请输入'
    }
  ]
}


export const attachmentOptions = function () {
  return [
    {
      type: 'FileUpload',
      title: '附件资料',
      colSpan: 24,
      [$field]: 'fileInfo',
      readOnly: true,
      props: {
        data: {
          groupId: ''
        },
        multiple: true,
        isShowFileList: true
      },
      rules: ['']
    },
    {
      type: 'textarea',
      title: '处理结果',
      colSpan: 24,
      readOnly: true,
      [$field]: 'projName',
      rules: ['']
    }
  ]
}

export const theSecondAttachmentOptions = function () {
  return [
    {
      type: 'FileUpload',
      title: '附件资料',
      colSpan: 24,
      [$field]: 'uploadFile',
      readOnly: true,
      props: {
        data: {
          groupId: ''
        },
        multiple: true,
        isShowFileList: true
      },
      rules: ['']
    },
    {
      type: 'Input',
      title: '处理组织',
      colSpan: 6,
      readOnly: true,
      [$field]: 'projName',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '反馈日期',
      colSpan: 6,
      readOnly: true,
      [$field]: 'projName',
      rules: ['']
    }
  ]
}